



















































































































import { Vue, Component } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { PubBiddingService } from "@/zh-website/src/views/partner/service/pubBidding";
import { VideoPlayer } from "@/zh-website/src/components";
import moment from "moment";

@Component({
  components: {
    SideBar,
    VideoPlayer
  }
})
export default class Index extends Vue {
  list = [];
  newsDetail: any = "";
  newsId = "";
  isExpired = true;
  mounted() {
    this.newsId = this.$route.params.aid;
    this.getNews();
    this.getNear();
    this._stopRight();
  }

  //阻止右键
  _stopRight() {
    const el: any = document.getElementById("tar");

    el.oncontextmenu = function(e) {
      //左键--button属性=1，右键button属性=2
      if (e.button == 2) {
        e.preventDefault();
      }
    };
  }
  //近期新闻
  async getNear() {
    PubBiddingService.getPubBiddingList({
      pageNum: 1,
      pageSize: 5,
      timeFrameCode: 1,
      excludeSubBiddingIds: this.newsId
    }).then((res: any) => {
      this.list = res.data.list;
    });
    // this.list = arr;
  }
  // 文章详情
  getNews() {
    // console.log(id);
    PubBiddingService.getPubBiddingCarousel({ id: this.newsId }).then(
      (res: any) => {
        this.newsDetail = res.data;
        this.isExpired = res.data.isExpired;
      }
    );
  }
  changeTime(time: string) {
    return moment(time).format("YYYY-MM-DD");
  }
  toApplySubmit() {
    this.$router.push({
      name: "pubBiddingApplySubmit"
    });
  }

  toPubBiddingFileDownload() {
    this.$router.push({
      name: "pubBiddingFileDownload"
    });
  }
}
